import { Action, Address, Link } from '@/types/general';

export enum StandingApprovalType {
  None = '',
  UpperLimit = 'upperLimit',
  ExactAmount = 'exactAmount'
}

export enum StandingApprovalPeriod {
  None = '',
  Month = 'month',
  Quarter = 'quarter',
  Semester = 'semester',
  Year = 'year'
}
interface StandingApproval {
  amount: string;
  currency: string;
  id: string;
  period: StandingApprovalPeriod;
  type: StandingApprovalType;
  _links: {
    self: Link;
  };
  _actions: {
    edit: Action;
    delete: Action;
  };
}

export enum BillerStatus {
  Active = 'active',
  Requested = 'requested',
  Blocked = 'blocked'
}

export enum BillerState {
  Active = 'active',
  Inactive = 'inactive'
}

export interface Biller {
  name: string;
  sector: string;
  requiresExternallyHostedSubscriptionForm: boolean;
  address: Address;
  website?: string;
  rank: number;
  logo_uri: string;
  biller_id: string;
  yap_uid: string;
  status?: BillerStatus;
  standingApprovals?: Array<StandingApproval>;
  _links: {
    self: Link;
    biller?: Link;
  };
  _actions?: {
    block?: Action;
    unblock?: Action;
    subscribe?: Action;
    unsubscribe?: Action;
    addStandingApproval?: Action;
  };
}

export interface EbillSubscription {
  registerDate: string;
  email: string;
  automaticBillerSubscription: boolean;
  address: {
    street: string;
    zip: string;
    town: string;
    country: string;
  };
  _links: {
    self: Link;
    unsubscribe: Link;
  };
  _actions: {
    unsubscribe: Action;
    editAutomaticBillerSubscription: Action;
    updateAddress: Action;
  };
}
